import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

class Alert extends Component {
  constructor(props) {
    super(props)

    this.state = {
      clearAlert: false,
      clearAlertTimeout: undefined
    }
  }

  componentDidMount() {
    const { alert } = this.props

    if (alert.type !== 'error') {
      const clearAlertTimeout = setTimeout(() => this.props.clearAlert(), 3000)

      this.setState({clearAlertTimeout})
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { clearAlert } = nextState

    if (clearAlert !== this.state.clearAlert) clearTimeout(this.state.clearAlertTimeout)
  }

  render() {
    const { alert } = this.props

    const className = classnames({
      'alert': true,
      'alert--animate': alert.type !== 'error',
      'alert--error': alert.type === 'error'
    })

    return (
      <div className={className}>
        <div className="clear-alert" onClick={() => this.setState({clearAlert: true}, () => this.props.clearAlert())} />

        {
          alert.type === 'error'
          ? <span>
              {alert.message}
              {/*Please <a onClick={() => window.location.reload()}>click here</a> to reload your browser.*/}
            </span>
          : alert.message
        }
      </div>
    )
  }
}

Alert.propTypes = {
  alert: PropTypes.object,
  clearAlert: PropTypes.func
}

Alert.defaultProps = {
  alert: {},
  clearAlert: function() {}
}

export default Alert



// WEBPACK FOOTER //
// ./src/components/common/alert.js